/**
 * Public API base path / origin.
 * On Vercel, set REACT_APP_API_URL="/api" (recommended) so the frontend calls the co-located API.
 * Locally, you can also leave it unset and rely on CRA `package.json.proxy`.
 */

// Hosts that serve this same app + API (the API answers on every one of them).
// An absolute REACT_APP_API_URL pointing at one of these is turned into the
// same-origin path, so a page opened on another of our hosts (or on a Vercel
// deployment URL) never makes a cross-origin call to a different host.
// (The two *.vercel.app hosts are built from the Vercel project names; never shown to users.)
export const OWN_APP_HOSTS = [
  ...['zaynic', 'rawaajmall'].map((project) => `${project}.vercel.app`),
  'rawaajmall.pk',
  'www.rawaajmall.pk',
];

export function resolveApiBase(raw) {
  const value = (raw || '/api').replace(/\/$/, '');
  if (!/^https?:\/\//i.test(value)) return value;
  try {
    const url = new URL(value);
    if (OWN_APP_HOSTS.includes(url.host.toLowerCase())) {
      return url.pathname.replace(/\/$/, '') || '/api';
    }
  } catch (e) {
    // fall through: keep the configured value
  }
  return value;
}

export const API_BASE = resolveApiBase(process.env.REACT_APP_API_URL);

/** Axios baseURL for v1 API. */
export function getApiV1BaseUrl() {
  return `${API_BASE}/v1`;
}

/** Uploaded files, JazzCash screenshots, prescription links (browser needs an absolute base). */
export function getPublicFileOrigin() {
  // If API_BASE is absolute (separate backend), use it. If it's relative (/api), use same-origin.
  return API_BASE.startsWith("http") ? API_BASE : "";
}
